// Function codes for students.
// Note: All "sub-codes" of these function codes are also considered student function codes.
// Examples of valid student codes and sub-codes: 4350, 4350-1, 4350-20312, 4350.2, 4350.21, 1050-1, 1050.1, 1050.2, 1050.20312
export const STUDENT_FUNCTION_CODES = ['1050', '4350', '9996', '9997', '9994']
